import { RootState } from 'store/rootReducer';

const mobileMenuOpenSelector = (state: RootState) => state.Common.isMobileMenuOpen;

const isPostHogEnabledSelector = (state: RootState) => state.Common.postHogConfigs.isPostHogEnabled;

export { isPostHogEnabledSelector, mobileMenuOpenSelector };
